
import "bootstrap/dist/css/bootstrap.min.css";

import Carousel from "react-bootstrap/Carousel";
import { useEffect, useState } from "react";
import request from "graphql-request";
import React from "react";

import CircularProgress from "@mui/material/CircularProgress";

export const SlideCourse = () => {
  const [slidesCarousel, setsetSlidesCarousel] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSlides = async () => {
      const response = await request(
        'https://api-sa-east-1.hygraph.com/v2/clikc8ct8012201uqatah7dr1/master',
        `
      {
        notifications(stage: PUBLISHED, orderBy: date_DESC, where: {sigecap: true}) {
          id
          slug
          url
          imgslides {
            url
          }         
          sigecap
        }
      }
    `
      );
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
      setsetSlidesCarousel(response.notifications);
    };
   
    fetchSlides();
  }, []);

if (slidesCarousel.length <= 0) {

  return (
    <>
    <center>
              <h4 style={{ color: "#568989" }}>Carregando informações.. </h4>
              <br />
              <CircularProgress />
            </center>  
      <br />            
<br />
<br />
  </>

  );
} else {
  return (
    <>
    {" "}
    <Carousel variant="dark" >  
              {slidesCarousel.length > 0 && slidesCarousel.map(notifications => (
               <Carousel.Item>
                    <a href={notifications.url} target="_blank">
                    <video loop
                      autoPlay
                      muted
                    >
                      <source src={notifications.imgslides.url} type="video/mp4"></source>
                    </video></a>
                  </Carousel.Item>
          )) }    
      </Carousel>      
      <br />            
<br />
<br />
  </>

  );
}
};

